import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPlanListing } from "../Services/Actions/planActions";
import "../Styles/Components/PricingCards.scss";
import { useNavigate } from "react-router-dom";

const PricingCards = () => {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [selectedPlanDuration, setSelectedPlanDuration] = useState(1); // 1 = monthly, 12 = yearly, 24 = 2 years
  const selectedCurrency = "R"; // ZAR currency
  const navigate = useNavigate();

  const handleTabChange = (path) => {
    navigate(path);
  };

  const {
    data: plansList = [],
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["getPlanListing"],
    queryFn: () =>
      getPlanListing({
        plan_users: 1,
        currency: "ZAR",
        type: "meet",
      }),
    select: (data) => data?.data || [],
    keepPreviousData: true,
    staleTime: 0,
    refetchOnMount: "always",
    cacheTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (plansList.length > 0) {
      const filteredPlans = plansList.filter(
        (plan) => plan.planID >= 5 && plan.planID <= 7
      );
      setPlans(filteredPlans);
    } else {
      refetch(); // fallback if query returned nothing
    }
  }, [plansList, refetch]);

  const onPlanSelectHandler = (plan) => {
    setSelectedPlanId(plan.planID);
  };

  if (isFetching && plans.length === 0) {
    return <div className="loading">Loading plans...</div>;
  }

  return (
    <div className="pricing-container">
      {plans.map((value, key) => {
        let planCost = value?.monthly_cost;
        if (selectedPlanDuration === 12) {
          planCost = value?.yearly_cost;
        } else if (selectedPlanDuration === 24) {
          planCost = value?.twoYear_cost;
        }

        const isHighlighted = key === 1;

        return (
          <div
            key={key}
            className={`pricing-card ${isHighlighted ? "highlighted" : ""}`}
            onClick={() => onPlanSelectHandler(value)}
          >
            <h3>{value.plan_name}</h3>

            <div className="price">
              {selectedCurrency} {planCost?.amount || "00"}
            </div>
            <div className="price-per">
              Per month (18% annual discount available)
            </div>

            <div className="best-for">
              <span>Participants:</span>{" "}
              {`Up to ${value.participants_for_video_confrence}`}
              <br />
              <span>Duration:</span> {`Up to ${value.video_calling_minutes}`}
            </div>

            <hr />

            <ul className="feature-list">
              {[
                value.plan_name === "Start Up" && [
                  "HD Video & Audio",
                  "Instant Browser Access (No Download Required)",
                  "Screen Sharing",
                  "Virtual Backgrounds",
                  "Secure Lobby for Private Meetings",
                ],
                value.plan_name === "Scale Up" && [
                  "Everything in Start-Up",
                  `${value.cloud_storage} Cloud Recording per Host`,
                  "Secure Meeting Lock",
                  "Meeting Transcripts",
                  "Breakout Rooms",
                  "Advanced Noise Removal",
                ],
                value.plan_name === "Professional" && [
                  "Everything in Scale-Up, PLUS",
                  "AI-Powered Transcription & Keynotes",
                  "Meeting Summaries & Insights",
                  `${value.cloud_storage} Cloud Storage per Host`,
                  "Live Streaming to YouTube & Facebook",
                  "Multi-Host & Co-Host Capabilities",
                  "File Sharing & Team Chat",
                ],
              ]
                .filter(Boolean)
                .flat()
                .map((feature, index) => (
                  <li key={index} className="feature-item">
                    <img
                      src="/assets/images/new_meet_page/check-circle.svg"
                      alt="Check"
                      className="feature-icon"
                    />
                    {feature}
                  </li>
                ))}
            </ul>

            <button
              onClick={() => handleTabChange("/signup")}
              className={`cta-button ${isHighlighted ? "highlighted" : ""}`}
            >
              {value.plan_name === "Enterprise" ? "Get a Demo" : "Try for Free"}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default PricingCards;
